import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Convert “#RRGGBB” → “#RRGGBB26” (≈ 15 % alpha). Pass through anything else. */
export const withLowAlpha = (c: string) =>
  /^#?[0-9a-f]{6}$/i.test(c) ? `${c.replace('#', '')}26` : c

/** Build a Tailwind arbitrary-value bg-image string, escaping spaces with "_". */
export const twLinear135 = (...stops: string[]) =>
  `bg-[linear-gradient(135deg,_${stops.join(',_')})]`
